<template>
  <div class="systemManage-create create-image">
    <el-dialog
      v-model="dialogVisible"
      :title="title"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="900px"
    >
      <div class="esls-page_content-table">
        <el-table
          :data="tableData"
          style="width: 100%"
          v-loading="tableLoading"
        >
          <el-table-column :label="$t('lcd.systemParameters.hasMarketId')">
            <el-table-column prop="marketTemplateId" min-width="150">
            </el-table-column>
          </el-table-column>
          <el-table-column
            :label="$t('lcd.systemParameters.noMarketId')"
            prop="code"
          >
            <el-table-column prop="noMarketTemplateId" min-width="180">
            </el-table-column>
          </el-table-column>
          <el-table-column
            align="center"
            :label="$t('lcd.systemParameters.StartTime')"
            prop="signalStrength"
          >
            <el-table-column align="center" prop="startTime" min-width="120">
            </el-table-column>
          </el-table-column>

          <el-table-column
            fixed="right"
            :label="$t('images.Action')"
            width="220"
            header-align="center"
          >
            <el-table-column align="center" width="220">
              <template slot="header"></template>
              <template slot="default" slot-scope="{ row }">
                <div class="operate">
                  <span class="operateBtn">
                    <!-- {{ $t("lcd.systemParameters.Delete auto temp") }} -->
                    <i class="el-icon-delete" @click="handleDelete(row)"></i>
                  </span>
                </div>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getAutoTempList, delAutoTempList } from "@/libs/api/lcd";

export default {
  name: "autoTempList",
  components: {},
  props: {},
  data() {
    return {
      title: this.$t("lcd.systemParameters.autoTemplateList"),
      userData: JSON.parse(localStorage.getItem("userData")),
      dialogVisible: false,
      tableLoading: false,
      tableData: [],
    };
  },
  created() {},
  mounted() {
    this.getList();
  },
  watch: {
    dialogVisible: function (val) {
      if (val) {
        this.getList();
      }
    },
  },
  methods: {
    getList() {
      this.tableLoading = true;
      const params = {};
      getAutoTempList(params).then((res) => {
        console.log(res);
        this.tableLoading = false;
        this.tableData = res.data.data.records;
      });
    },

    // 删除方法
    handleDelete(row) {
      console.log(row);
      const params = {
        id: row.id,
      };
      this.$confirm(
        this.$t("lcd.systemParameters.Delete tips"),
        this.$t("devices.tips"),
        {
          confirmButtonText: this.$t("devices.sure"),
          cancelButtonText: this.$t("devices.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          delAutoTempList(params).then((res) => {
            console.log(res);
            if(res.data.code == 1){
              this.$message({
              message: this.$t('devices.deleteSuccessTips'),
              type: "success",
            });
            this.getList();
            }
            
          });
        })
        .catch(() => {});
    },

    // 打开弹窗
    open() {
      this.dialogVisible = true;
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.create-image {
  // 重置样式
  ::v-deep .el-dialog {
    margin-top: 15vh !important;
  }
}
.systemManage-create.create-image {
  .form-box {
    width: 500px;
  }
  .file-list {
    display: flex;
  }
  .form-btn-section {
    margin-top: 60px;
  }
  .el-select,
  .el-input--small {
    width: 82%;
    margin-right: 10px;
  }
  ::v-deep .el-tag {
    margin-bottom: 10px;
    max-width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    position: relative;
    padding-right: 30px;
    // word-wrap: break-word;
    // word-break: break-all;
    .el-icon-close {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}
.select-group {
  .table-icon {
    padding: 6px;
    cursor: pointer;
    font-size: 18px;
    color: #000;
  }
}

.resolutionInput {
  margin-right: 12px;
  ::v-deep .el-input__inner {
    border: none !important;
    height: 28px;
    line-height: 28px;
    background-color: #f5f7fa;
  }
}
</style>